import { useEffect, useMemo } from "react";
import { isEmpty } from "lodash";
import { useLocalStorage } from "@/react/hooks/utils/useLocalStorage";

export interface UseReactQueryLocalStorageProps<TData> {
  data: TData | undefined;
  defaultValue: TData;
  key: string;
}

export interface UseReactQueryLocalStorageReturn<TData> {
  data: TData;
  isLoading: boolean;
}

export const useReactQueryLocalStorage = <TData>({
  key,
  data,
  defaultValue,
}: UseReactQueryLocalStorageProps<TData>): UseReactQueryLocalStorageReturn<TData> => {
  const { getValue, setValue } = useLocalStorage<TData>(key);
  const fromLocalStorage = useMemo(() => getValue(), [getValue]);

  useEffect(() => {
    if (!isEmpty(data) && data !== undefined) {
      setValue(data);
    }
  }, [setValue, data]);

  const responseData = data || fromLocalStorage || defaultValue;

  return {
    data: responseData,
    isLoading: isEmpty(responseData),
  };
};
